'use strict'
angular.module('manuscriptAttributeConfigServiceModule', [
        'manuscriptAttributeConfigCreatedAttributeModule'
    ])
    .factory('manuscriptAttributeConfigService', ['$modal', '$q', function($modal, $q) {
        return {
            createdAttribute: function(item) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/sysManageMent/manuscriptAttributeConfig/service/createdAttribute/createdAttribute_tpl.html',
                    windowClass: 'manuscriptAttributeConfigModal',
                    controller: 'manuscriptAttributeConfigCreatedAttributeCtrl',
                    backdrop: false,
                    resolve: {
                        attrBaseData: function() {
                            return item;
                        }
                    }
                });
                modalInstance.result.then(function(success){
                	defer.resolve(success);
                }, function(){});
                return defer.promise;
            }
        };
    }]);